import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface OrdersState {
  orderIds: string[];
  setOrderIds: (orderIds: string[]) => void;
  addOrderId: (orderId: string) => void;
  resetOrderIds: () => void;
}

export const useOrders = create<OrdersState>()(
  persist(
    (set) => ({
      orderIds: [],
      setOrderIds: (orderIds: string[]) => {
        set({ orderIds });
      },
      addOrderId: (orderId: string) => {
        set((state) => ({ orderIds: [...state.orderIds, orderId] }));
      },
      resetOrderIds: () => {
        set({ orderIds: [] });
      },
    }),
    {
      name: "orders-store",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
